import {
  EXHIBITORSINSIGHT_NOOFEXHI,
  EXHIBITORSINSIGHT_EXHILISTVIEW,
  EXHIBITORSINSIGHT_EXHIPROFVIEW,
  EXHIBITORSINSIGHT_EXHISEARCH,
  EXHIBITORSINSIGHT_EXHIFAVO,
  EXHIBITORSINSIGHT_ITEM_SELECTED,
  EXHIBITORSINSIGHT_TOPEXHI_TABLELIST,
  EXHIBITORSINSIGHT_MOSTSEARKEYS_TABLELIST,
  EXHIBITORSINSIGHT_TOPTAGS_TABLELIST,
  EXHIBITORSINSIGHT_TOPEXHICOUN_TABLELIST,
  EXHIBITORSINSIGHT_ENGAGEMENT_BARCHART,
} from "ExhibitorinsightActions";

export var ExhibitorInsightMenu = (state = [], action) => {
  //iconName is optional
  var state = [
    {
      key: EXHIBITORSINSIGHT_NOOFEXHI,
      iconName: "noofexhi",
      sectionName: "Number of Exhibitors",
      sectionDesc: "How many Exhibitors are there in the event",
      selected: false,
    },
    {
      key: EXHIBITORSINSIGHT_EXHILISTVIEW,
      iconName: "exhilistview",
      sectionName: "Exhibitors's list views",
      sectionDesc: "Number of user who browsed through the exhibitors list",
      selected: false,
    },
    {
      key: EXHIBITORSINSIGHT_EXHIPROFVIEW,
      iconName: "exhiprofview",
      sectionName: "Exhibitors's profile views",
      sectionDesc:
        "Number of user who browsed through the exhibitors's profiles",
      selected: false,
    },
    {
      key: EXHIBITORSINSIGHT_EXHISEARCH,
      iconName: "exhisearch",
      sectionName: "Exhibitor searches",
      sectionDesc: "Number of searches done on exhibitor list",
      selected: false,
    },
    {
      key: EXHIBITORSINSIGHT_EXHIFAVO,
      iconName: "exhifavo",
      sectionName: "Exhibitor favourites",
      sectionDesc: "Number of bookmarked exhibitors profiles",
      selected: false,
    },
  ];

  var index = 0;
  state[index].selected = true;

  return state;
};

// Initial select tab is "EXHIBITORSINSIGHT_NOOFEXHI"
export var ExhibitorsinsightSelectedItem = (
  state = EXHIBITORSINSIGHT_NOOFEXHI,
  action
) => {
  if (action.type == EXHIBITORSINSIGHT_ITEM_SELECTED) {
    state = action.payload.key;
  }

  return state;
};

/*****  Local reducers for most search keywords related to exhibitors netword  ******/
export var ExhibitorsinsightMostsearkeysTablelist = (state = {}, action) => {
  switch (action.type) {
    case EXHIBITORSINSIGHT_MOSTSEARKEYS_TABLELIST:
      return action.data;
    default:
      return state;
  }
};

// Local reducers for exhibitors profiles with most user engagement
export var ExhibitorsinsightTopexhiTablelist = (state = {}, action) => {
  switch (action.type) {
    case EXHIBITORSINSIGHT_TOPEXHI_TABLELIST:
      return action.data;
    default:
      return state;
  }
};

// Local reducers for most used tags related to exhibitors
export var ExhibitorsinsightToptagsexhiTablelist = (state = {}, action) => {
  switch (action.type) {
    case EXHIBITORSINSIGHT_TOPTAGS_TABLELIST:
      return action.data;
    default:
      return state;
  }
};

// Local reducers for Countries from which top exhibitors belongs
export var ExhibitorsinsightTopcountriesexhiTablelist = (
  state = {},
  action
) => {
  switch (action.type) {
    case EXHIBITORSINSIGHT_TOPEXHICOUN_TABLELIST:
      return action.data;
    default:
      return state;
  }
};

// Local reducer for {Exhibitors Engagement (Chart view of how actively the exhibitor feature has been use over the selected date range)}

export const ExhibitorsinsightEngagementbarChart = (state = {}, action) => {
  switch (action.type) {
    case EXHIBITORSINSIGHT_ENGAGEMENT_BARCHART:
      return action.payload;
      break;
    default:
      return state;
      break;
  }
};
